import { useEffect, useState } from 'react';

const useFirebaseLoader = () => {
  const [firebaseReady, setFirebaseReady] = useState(false);

  useEffect(() => {
    const checkIfReady = () => {
      const firebase = (window as any).firebase;

      if (firebase) {
        if (!firebase.apps.length && firebase.initializeApp) {
          firebase.initializeApp({
            apiKey: 'AIzaSyD2gPW474Ymmfw45eraB9OvWi2w9DqpiyU',
            appId: '1:259420669198:web:90432edeb5e2e5cf7dc35f',
            authDomain: 'imgcp-369230c31642aca9.firebaseapp.com',
            messagingSenderId: '259420669198',
            projectId: 'imgcp-369230c31642aca9',
            storageBucket: 'imgcp-369230c31642aca9.appspot.com',
            // apiKey: 'AIzaSyCpwPRVcJQ4HoVc6XWkJiYf2fHQjZ6zk-k',
            // appId: '1:54314004418:web:770f717b670c2222ab305b',
            // authDomain: 'imgcp-0901539eb61e81e2.firebaseapp.com',
            // messagingSenderId: '54314004418',
            // projectId: 'imgcp-0901539eb61e81e2',
            // storageBucket: 'imgcp-0901539eb61e81e2.appspot.com',
          });
        }

        if (firebase.messaging && typeof firebase.messaging === 'function') {
          const messaging = firebase.messaging();
          (window as any).firebaseMessaging = messaging;
          setFirebaseReady(true);
        } else {
          setTimeout(checkIfReady, 200);
        }
      } else {
        // console.warn('⏳ window.firebase not ready');
        setTimeout(checkIfReady, 200);
      }
    };

    checkIfReady();
  }, []);

  return firebaseReady;
};

// ✅ Named export
export { useFirebaseLoader };
